window.ListarNotasFiscaisSaidaController = ControllerBase.extend({
    name: 'ListarNotasFiscaisSaidaController',
    framework: 'knockout',

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Filial', prop: 'Filial' },
            { title: 'Nº Orçamento', prop: 'NumeroPedido' },
            { title: 'Cliente', prop: 'RazaoSocialCliente' },
            { title: 'Vendedor', prop: 'Vendedor' },
            { title: 'Data', prop: 'DataPedido', type: 'Date' },
            { title: 'Valor', prop: 'ValorPedido', type: 'Money' }
        ],
        getData: function () {
            return ko.mapping.toJS(this.orcamento);
        },
    }),

    ajax: function () {
        return {
            url: '/NotaFiscalSaida/_NotasFiscais',
            type: 'post',
            data: {
                numeroOrcamento: this.orcamento.NumeroPedido()
            }
        };
    },

    renderizado: function () {
        this.modelPesquisa.NotasFiscais(true);
        this.modelPesquisa.NotaVenda(true);
    },

    antesBinding: function () {
        this.appendToModel({ name: 'notaSelecionada', value: null });
        this.appendToModel({ name: 'tipoEntrega', value: null });
    },

    onhide: function () {
        this.modelPesquisa.NotasFiscais(false);
        this.modelPesquisa.NotaSelecionada(false);
        this.modelPesquisa.NotaVenda(false);
    },

    selecionar: function (model) {
        this.model.notaSelecionada(model);
        this.modelPesquisa.NotaSelecionada(true);
    },

    itens: function () {

        this.ItensNotaFiscalSaidaController = this.showView({
            region: {
                name: 'ItensNotaFiscalSaidaControllerRegion',
                selector: '#itens-nota-fiscal-region'
            },
            controller: {
                type: ItensNotaFiscalSaidaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa,
                    nf: ko.mapping.toJS(this.model.notaSelecionada())
                }
            }
        });
    },

    lotes: function () {
        this.ItensNotaFiscalSaidaController = this.showView({
            region: {
                name: 'LotesNotaFiscalSaidaControllerRegion',
                selector: '#lotes-item-nota-fiscal-region'
            },
            controller: {
                type: LotesNotaFiscalSaidaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa,
                    nf: ko.mapping.toJS(this.model.notaSelecionada())
                }
            }
        });
    },

    entrega: function () {
        this.EntregaNotaFiscalSaidaController = this.showView({
            region: {
                name: 'EntregaNotaFiscalSaidaControllerRegion',
                selector: '#entrega-nota-fiscal-region'
            },
            controller: {
                type: EntregaNotaFiscalSaidaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa,
                    nf: ko.mapping.toJS(this.model.notaSelecionada())
                }
            }
        });
    },
    financeiro: function () {
        this.EntregaNotaFiscalSaidaController = this.showView({
            region: {
                name: 'financeiroNotaFiscalOrcamentoControllerRegion',
                selector: '#financeiro-nota-fiscal-region'
            },
            controller: {
                type: ContasReceberNotaFiscalSaidaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa,
                    nf: ko.mapping.toJS(this.model.notaSelecionada())
                }
            }
        });
    },
    expedicao: function () {
        this.EntregaNotaFiscalSaidaController = this.showView({
            region: {
                name: 'ExpedicaoNotaFiscalSaidaControllerRegion',
                selector: '#expedicao-nota-fiscal-region'
            },
            controller: {
                type: ExpedicaoNotaFiscalSaidaController,
                args: {
                    notaFiscal: this.model.notaSelecionada(),
                    modelPesquisa: this.modelPesquisa,
                    nf: ko.mapping.toJS(this.model.notaSelecionada())
                }
            }
        });
    }
});